import { DISPLAY_LANG } from '../../../config';
import './Modal.css';

export default function Modal({ modalData, setModalData, setShowModal }) {
    const handleClose = () => {
        setShowModal(false);
        setModalData(null);

        // search paramn em maqrum
        window.history.replaceState(null, "", window.location.pathname);

        // cookinern em maqrum
        document.cookie.split(";").forEach(cookie => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
        });
    };

    return (
        <div className='Modal'>
            <div className="bg"></div>

            <div className={`content ${modalData.status === 'failed' ? 'error' : ''}`}>
                <span className='close' onClick={handleClose}>&times;</span>

                {
                    modalData.status === 'success' && (<>
                        <h3>✅</h3>
                        <h2>{modalData.message[DISPLAY_LANG].split('/')[0]}</h2>
                    </>)
                }

                {
                    modalData.status === 'failed' && (<>
                        <h2>{modalData.message[DISPLAY_LANG].split('/')[0]}</h2>
                        <p>{modalData.message[DISPLAY_LANG].split('/')[1]}</p>
                    </>)
                }
            </div>
        </div>
    )
}